import DropdownMenu from "@/components/util/menu/DropdownMenu"
import {
  Button,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  MenuItem
} from "@material-ui/core"
import {
  AccountTree,
  Pageview,
  PeopleRounded,
  SettingsApplicationsRounded,
  SportsHandball
} from "@material-ui/icons"
import AccountTreeIcon from "@material-ui/icons/AccountTree"
import BookIcon from "@material-ui/icons/Book"
import BookmarksIcon from "@material-ui/icons/Bookmarks"
import FindInPageIcon from "@material-ui/icons/FindInPage"
import MapIcon from "@material-ui/icons/Map"
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf"
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import useAuth from "../auth/useAuth"

const useStyles = makeStyles(theme => ({
  menuName: {
    fontSize: 16,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  }
}))

export default function AdminMenu() {
  const classes = useStyles()
  const { user } = useAuth()
  const { t } = useTranslation()

  const current_org = user?.organisation?.id

  return (
    <PopupState variant="popover" popupId="reports">
      {popupState => (
        <React.Fragment>
          <Button color="inherit" {...bindTrigger(popupState)}>
            <span className={classes.menuName}>Admin</span>
          </Button>
          <DropdownMenu {...bindMenu(popupState)}>
            <ListItem>
              <ListItemText
                primary="Data Lookup Tools"
                primaryTypographyProps={{ variant: "caption" }}
              />
            </ListItem>
            <MenuItem
              component={Link}
              to="/admin/datasetcomparisontool"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary="Dataset Comparison Tool" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/accountbloodlineviewer"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <AccountTreeIcon />
              </ListItemIcon>
              <ListItemText primary="Account Bloodline Viewer" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/jsonatatestingplayground"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <SportsHandball />
              </ListItemIcon>
              <ListItemText primary="Jsonata Testing Playground" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/datasetlookupbyuploadid"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <MapIcon />
              </ListItemIcon>
              <ListItemText primary="Datasets By Upload ID" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/instructioncomparisontool"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <Pageview />
              </ListItemIcon>
              <ListItemText primary="Instruction Comparison Tool" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/instructionLivedocsLookup"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <FindInPageIcon />
              </ListItemIcon>
              <ListItemText primary="Instruction Livedocs Lookup" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/jsonpathcopytool"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <Pageview />
              </ListItemIcon>
              <ListItemText primary="JSON Path Copy Tool" />
            </MenuItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary="Data Management"
                primaryTypographyProps={{ variant: "caption" }}
              />
            </ListItem>
            <MenuItem
              component={Link}
              to="/admin/assets"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookIcon />
              </ListItemIcon>
              <ListItemText primary="Assets" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/banks"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookmarksIcon />
              </ListItemIcon>
              <ListItemText primary="Banks" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/bankAccounts"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookmarksIcon />
              </ListItemIcon>
              <ListItemText primary="Bank Accounts" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/branches"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookmarksIcon />
              </ListItemIcon>
              <ListItemText primary="Branches" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/countries"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookIcon />
              </ListItemIcon>
              <ListItemText primary="Countries" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/documentTypeTables"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText primary={t("Document Type Tables")} />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/dsr"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <PeopleRounded />
              </ListItemIcon>
              <ListItemText primary="DSR" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/entities"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookIcon />
              </ListItemIcon>
              <ListItemText primary="Entities" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/entitypackages"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookIcon />
              </ListItemIcon>
              <ListItemText primary="Entity Packages" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/establishments"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookIcon />
              </ListItemIcon>
              <ListItemText primary={t("Establishments")} />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/funds"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookIcon />
              </ListItemIcon>
              <ListItemText primary="Funds" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/organisationPackages"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookmarksIcon />
              </ListItemIcon>
              <ListItemText primary="Organisation Packages" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/organisations"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookmarksIcon />
              </ListItemIcon>
              <ListItemText primary="Organisations" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/uploads"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookmarksIcon />
              </ListItemIcon>
              <ListItemText primary="Uploads" />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/admin/users"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <BookmarksIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </MenuItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary="Settings"
                primaryTypographyProps={{ variant: "caption" }}
              />
            </ListItem>
            <MenuItem
              component={Link}
              to={"/admin/organisations/" + current_org}
              onClick={popupState.close}
            >
              <ListItemIcon>
                <SettingsApplicationsRounded />
              </ListItemIcon>
              <ListItemText primary="Current Organisation Settings" />
            </MenuItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary="Data Visualizations"
                primaryTypographyProps={{ variant: "caption" }}
              />
            </ListItem>
            <MenuItem
              component={Link}
              to="/admin/categoryTrees"
              onClick={popupState.close}
            >
              <ListItemIcon>
                <AccountTree />
              </ListItemIcon>
              <ListItemText primary="Category Trees" />
            </MenuItem>
          </DropdownMenu>
        </React.Fragment>
      )}
    </PopupState>
  )
}
